import { ReactNode } from 'react';
import { usePermissions } from '@/hooks/auth/usePermissions';

interface CanProps {
  permission?: string;
  permissions?: string[];
  requireAll?: boolean;
  children: ReactNode;
  fallback?: ReactNode;
}

export const Can = ({
  permission,
  permissions,
  requireAll = false,
  children,
  fallback = null,
}: CanProps) => {
  const { can, canAny, canAll } = usePermissions();

  let hasAccess = false;

  if (permission) {
    hasAccess = can(permission);
  } else if (permissions) {
    hasAccess = requireAll ? canAll(permissions) : canAny(permissions);
  }

  return <>{hasAccess ? children : fallback}</>;
};
